module.exports = __webpack_public_path__ + "images/icon-express.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-express.png
// module id = gvhk
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15